import {  inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { PERMISSION_CONFIG_TOKEN } from '@/core/util/permission.token';
import { PERMISSION_SERVICE_TOKEN } from '@/core/util/permission-service.token';
import { Action } from '@/core/util/permission-action';


export abstract class BasePermission {
    protected ps = inject(PERMISSION_SERVICE_TOKEN);
    protected tpl = inject(TemplateRef<any>);
    protected vcr = inject(ViewContainerRef);
    protected config = inject(PERMISSION_CONFIG_TOKEN);

    protected checkPermission(action: Action) {
        this.vcr.clear();
        if (!this.config.enabled) {
            this.vcr.createEmbeddedView(this.tpl);
            return;
        }
        if (this.ps.featureActions().has(action)) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }
}
